import TshirtClub from './TshirtClub';

import useGetClubColorById from '@/hooks/useGetClubColorById';

interface Props {
  type: 'SHIRT' | 'SHIELD';
  clubId: number | undefined;
  playerId: number | undefined;
}

const Clubs = ({ type, clubId, playerId }: Props) => {
  const clubColors = useGetClubColorById(clubId);

  if (type === 'SHIRT') {
    return (
      <TshirtClub
        colors={{
          startColor: clubColors.primary,
          endColor: clubColors.secondary,
        }}
        id={playerId}
      />
    );
  }

  return null;
};

export default Clubs;
